// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xwUB","badges":"styles_badges__3DEY8"};